/* Project Unity hero: background video, rotating hero word, experts rail and the
   .pu-anim root flag + outcome-card safety timer. Loaded by the homepage, why and
   business sections. Requires project-unity-core.js for nothing; standalone. */
(function () {
  document.querySelectorAll('[data-project-unity]').forEach(function (root) {
  if (root.dataset.puHeroReady === 'true') return;
  root.dataset.puHeroReady = 'true';
  root.classList.add('pu-anim');
  function settleOutcomeCard(card) {
    window.setTimeout(function () {
      if (card.classList.contains('is-revealed')) card.classList.add('is-settled');
    }, 2600);
  }
  window.setTimeout(function () {
    root.querySelectorAll('[data-outcome-card]:not(.is-revealed)').forEach(function (card) {
      const rect = card.getBoundingClientRect();
      if (rect.top < window.innerHeight * 2) { card.classList.add('is-revealed'); settleOutcomeCard(card); }
    });
  }, 2500);

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* The background footage waits until the page has loaded and gone idle (or the visitor taps, types or
     scrolls with a wheel); the poster shows until then. Lighthouse homepage, 19 Oct 2026, 5 runs each:
     score 57 -> 63, Speed Index 6.6 s -> 5.3 s. Holding the rotating word as well measured no difference,
     so the word keeps rotating from the start. Preview themes can compare ?pu_hero_test=off|word|video|both. */
  const HERO_SETTLE_DEFAULT = 'video';
  const heroSettleMode = (function () {
    try {
      const preview = window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main';
      const requested = preview ? new URLSearchParams(window.location.search).get('pu_hero_test') : null;
      return /^(off|word|video|both)$/.test(requested || '') ? requested : HERO_SETTLE_DEFAULT;
    } catch (error) { return HERO_SETTLE_DEFAULT; }
  })();
  function whenPageSettled(callback) {
    let done = false;
    const triggers = ['pointerdown', 'keydown', 'touchstart', 'wheel'];
    const go = function () {
      if (done) return;
      done = true;
      triggers.forEach(function (name) { document.removeEventListener(name, go, true); });
      callback();
    };
    triggers.forEach(function (name) { document.addEventListener(name, go, { capture: true, passive: true }); });
    const afterLoad = function () {
      if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(go, { timeout: 3000 });
      else window.setTimeout(go, 1500);
    };
    if (document.readyState === 'complete') afterLoad();
    else window.addEventListener('load', afterLoad, { once: true });
  }

  const heroVideo = root.querySelector('[data-hero-video]');
  const heroMobileQuery = window.matchMedia('(max-width: 767px)');
  const heroMotionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  let heroLoadTimer = 0;
  let heroUserPaused = false;
  let heroInView = true;
  let heroUserPlayed = false;
  let heroFailed = false;
  let heroWebMFailed = false;
  let heroPlayPending = false;
  let heroPlayAttempt = 0;
  let heroControl = null;

  /* The footage must not compete with the poster's own paint. On a slow device the request
     would otherwise start before the poster is on screen and join Lighthouse's LCP dependency
     graph (measured: 11 s simulated LCP versus 3.5 s). Start 250 ms after the poster image has
     decoded and had two frames to paint (the first LCP entry can be the headline, so it is only
     the fallback when there is no poster image), with a hard ceiling so playback never waits
     on metrics. A tap on the control starts it immediately. */
  let heroStartAllowed = false;
  let heroStartPending = false;
  function allowHeroStart() {
    if (heroStartAllowed) return;
    heroStartAllowed = true;
    if (heroStartPending) loadHeroVideo();
  }
  (function scheduleHeroStart() {
    if (heroSettleMode === 'video' || heroSettleMode === 'both') { whenPageSettled(allowHeroStart); return; }
    let scheduled = false;
    const afterPaint = function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () { window.setTimeout(allowHeroStart, 250); });
      });
    };
    const heroContainer = heroVideo ? heroVideo.closest('.pu-hero') : null;
    const posterImage = heroContainer ? heroContainer.querySelector('.pu-hero__media img') : null;
    try {
      if (posterImage) {
        const whenDecoded = function () {
          if (typeof posterImage.decode === 'function') posterImage.decode().then(afterPaint, afterPaint);
          else afterPaint();
        };
        if (posterImage.complete) whenDecoded();
        else {
          posterImage.addEventListener('load', whenDecoded, { once: true });
          posterImage.addEventListener('error', afterPaint, { once: true });
        }
      } else {
        const types = window.PerformanceObserver && PerformanceObserver.supportedEntryTypes;
        if (types && types.indexOf('largest-contentful-paint') !== -1) {
          const paintObserver = new PerformanceObserver(function (list) {
            if (!list.getEntries().length) return;
            paintObserver.disconnect();
            afterPaint();
          });
          paintObserver.observe({ type: 'largest-contentful-paint', buffered: true });
        } else afterPaint();
      }
    } catch (error) {
      afterPaint();
    }
    window.setTimeout(allowHeroStart, 6000);
  })();

  function updateHeroControl() {
    if (!heroControl) return;
    const paused = heroVideo.paused && !heroPlayPending;
    heroControl.classList.toggle('is-paused', paused);
    heroControl.setAttribute('aria-label', heroFailed ? 'Retry background video' : paused ? 'Play background video' : 'Pause background video');
  }

  function setHeroVideoState(state) {
    if (heroVideo) heroVideo.dataset.videoState = state;
    updateHeroControl();
  }

  function shouldPlayHero() {
    return heroVideo && heroInView && !document.hidden && !heroUserPaused && !heroFailed && (!heroMotionPreference.matches || heroUserPlayed);
  }

  function pauseHeroVideo(detach) {
    if (!heroVideo) return;
    window.clearTimeout(heroLoadTimer);
    heroPlayAttempt += 1;
    heroPlayPending = false;
    heroVideo.pause();
    if (detach) {
      heroVideo.removeAttribute('src');
      heroVideo.querySelectorAll('source').forEach(function (source) { source.removeAttribute('src'); });
      heroVideo.load();
      heroVideo.classList.remove('is-playing');
    }
    updateHeroControl();
  }

  function attemptHeroVideoPlay() {
    if (!shouldPlayHero() || heroPlayPending || !heroVideo.getAttribute('src')) return;
    // Preserve the poster until a frame is ready; early play() clears it while buffering.
    if (!heroUserPlayed && heroVideo.readyState < 2) return;
    if (!heroVideo.paused && heroVideo.readyState >= 2) return;
    heroVideo.muted = true;
    heroVideo.defaultMuted = true;
    heroVideo.playsInline = true;
    heroPlayPending = true;
    const attempt = ++heroPlayAttempt;
    updateHeroControl();
    const revealPlayableVideo = function () {
      if (attempt !== heroPlayAttempt) return;
      heroPlayPending = false;
      if (!shouldPlayHero()) {
        heroVideo.pause();
      } else if (heroVideo.readyState >= 2 && !heroVideo.paused) {
        window.clearTimeout(heroLoadTimer);
        heroVideo.classList.add('is-playing');
        setHeroVideoState('playing');
      }
      updateHeroControl();
    };
    const playPromise = heroVideo.play();
    if (playPromise && typeof playPromise.then === 'function') {
      playPromise.then(revealPlayableVideo).catch(function () {
        if (attempt !== heroPlayAttempt) return;
        heroPlayPending = false;
        heroFailed = Boolean(heroVideo.error);
        heroVideo.classList.remove('is-playing');
        setHeroVideoState(heroFailed ? 'error' : 'paused');
      });
    } else revealPlayableVideo();
  }

  function loadHeroVideo() {
    if (!heroVideo) return;
    window.clearTimeout(heroLoadTimer);
    if (!heroStartAllowed && !heroUserPlayed) {
      heroStartPending = true;
      return;
    }
    if (heroMotionPreference.matches && !heroUserPlayed) {
      pauseHeroVideo(true);
      setHeroVideoState('reduced-motion');
      return;
    }
    if (!shouldPlayHero()) {
      pauseHeroVideo(false);
      return;
    }
    const poster = heroMobileQuery.matches ? heroVideo.dataset.mobilePoster : heroVideo.dataset.desktopPoster;
    if (poster && heroVideo.getAttribute('poster') !== poster) heroVideo.poster = poster;
    const mobileWebM = !heroWebMFailed && heroVideo.dataset.mobileWebm && heroVideo.canPlayType('video/webm; codecs="vp9"');
    const source = heroMobileQuery.matches ? (mobileWebM ? heroVideo.dataset.mobileWebm : heroVideo.dataset.mobileSrc) : heroVideo.dataset.desktopSrc;
    if (!source) {
      setHeroVideoState('missing-source');
      return;
    }
    if (heroVideo.getAttribute('src') !== source) {
      pauseHeroVideo(false);
      heroVideo.classList.remove('is-playing');
      heroVideo.preload = 'auto';
      heroVideo.setAttribute('src', source);
      heroVideo.load();
    }
    setHeroVideoState('loading');
    attemptHeroVideoPlay();
    heroLoadTimer = window.setTimeout(function () {
      if (!shouldPlayHero() || heroVideo.readyState > 0 || heroVideo.error) return;
      setHeroVideoState('retrying');
      heroPlayAttempt += 1;
      heroPlayPending = false;
      heroVideo.load();
      attemptHeroVideoPlay();
    }, 8000);
  }

  if (heroVideo) {
    heroVideo.autoplay = false;
    heroVideo.removeAttribute('autoplay');
    heroVideo.preload = 'none';
    heroVideo.querySelectorAll('source').forEach(function (source) { source.removeAttribute('src'); });
    heroVideo.muted = true;
    heroVideo.defaultMuted = true;
    heroVideo.playsInline = true;
    if (!heroVideo.id) heroVideo.id = 'pu-hero-video-' + (Array.prototype.indexOf.call(document.querySelectorAll('[data-hero-video]'), heroVideo) + 1);
    const heroContainer = heroVideo.closest('.pu-hero');
    if (heroContainer) {
      heroControl = document.createElement('button');
      heroControl.className = 'pu-labs__video-toggle is-paused';
      heroControl.type = 'button';
      heroControl.setAttribute('data-pu-hero-video-toggle', '');
      heroControl.setAttribute('aria-controls', heroVideo.id);
      heroControl.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path data-pu-video-play d="M7 5.2 15 10l-8 4.8Z" stroke="none"></path><g data-pu-video-pause><path d="M7 5v10M13 5v10" fill="none"></path></g></svg>';
      heroContainer.appendChild(heroControl);
      heroControl.addEventListener('click', function () {
        if (!heroFailed && (!heroVideo.paused || heroPlayPending)) {
          heroUserPaused = true;
          heroUserPlayed = false;
          pauseHeroVideo(false);
          setHeroVideoState('paused');
          return;
        }
        if (heroFailed) {
          heroFailed = false;
          heroVideo.removeAttribute('src');
          heroVideo.load();
        }
        heroUserPaused = false;
        heroUserPlayed = true;
        loadHeroVideo();
      });
    }
    heroVideo.addEventListener('loadeddata', attemptHeroVideoPlay);
    heroVideo.addEventListener('canplay', attemptHeroVideoPlay);
    heroVideo.addEventListener('playing', function () {
      if (!shouldPlayHero()) {
        pauseHeroVideo(heroMotionPreference.matches && !heroUserPlayed);
        return;
      }
      window.clearTimeout(heroLoadTimer);
      heroVideo.classList.add('is-playing');
      setHeroVideoState('playing');
    });
    heroVideo.addEventListener('pause', updateHeroControl);
    heroVideo.addEventListener('error', function () {
      if (!heroWebMFailed && heroVideo.getAttribute('src') === heroVideo.dataset.mobileWebm) {
        heroWebMFailed = true;
        heroPlayPending = false;
        loadHeroVideo();
        return;
      }
      heroFailed = true;
      pauseHeroVideo(false);
      heroVideo.classList.remove('is-playing');
      setHeroVideoState('error');
    });
    const heroMotionChanged = function () {
      heroUserPlayed = false;
      if (heroMotionPreference.matches) {
        heroFailed = false;
        pauseHeroVideo(true);
        setHeroVideoState('reduced-motion');
      } else loadHeroVideo();
    };
    if (heroMotionPreference.addEventListener) heroMotionPreference.addEventListener('change', heroMotionChanged);
    else if (heroMotionPreference.addListener) heroMotionPreference.addListener(heroMotionChanged);
    if (heroMobileQuery.addEventListener) heroMobileQuery.addEventListener('change', loadHeroVideo);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pauseHeroVideo(false);
      else loadHeroVideo();
    });
    if ('IntersectionObserver' in window) {
      const heroObserver = new IntersectionObserver(function (entries) {
        heroInView = entries[0].isIntersecting;
        if (heroInView) loadHeroVideo();
        else pauseHeroVideo(false);
      });
      heroObserver.observe(heroContainer || heroVideo);
    }
    loadHeroVideo();
  }

  const rotatingWord = root.querySelector('[data-rotating-word]');
  const rotatingWords = rotatingWord && rotatingWord.dataset.rotatingWords
    ? rotatingWord.dataset.rotatingWords.split('|').filter(Boolean)
    : ['health', 'sleep', 'recovery', 'performance', 'longevity'];
  let rotatingIndex = 0;
  if (rotatingWord && rotatingWords.length > 1 && !reducedMotion) {
    const startRotation = function () { window.setInterval(function () {
      rotatingIndex = (rotatingIndex + 1) % rotatingWords.length;
      rotatingWord.animate(
        [{ opacity: 1, transform: 'translateY(0)', filter: 'blur(0px)' }, { opacity: 0, transform: 'translateY(-8px)', filter: 'blur(4px)' }],
        { duration: 260, easing: 'cubic-bezier(.4, 0, .6, 1)', fill: 'forwards' }
      ).finished.then(function () {
        rotatingWord.textContent = rotatingWords[rotatingIndex];
        rotatingWord.animate(
          [{ opacity: 0, transform: 'translateY(10px)', filter: 'blur(6px)' }, { opacity: 1, transform: 'translateY(0)', filter: 'blur(0px)' }],
          { duration: 640, easing: 'cubic-bezier(.16, 1, .3, 1)', fill: 'forwards' }
        );
      });
    }, 1800); };
    if (heroSettleMode === 'word' || heroSettleMode === 'both') whenPageSettled(startRotation);
    else startRotation();
  }

  const expertsTrack = root.querySelector('[data-experts-row]');
  const expertsPrevious = root.querySelector('[data-experts-prev]');
  const expertsNext = root.querySelector('[data-experts-next]');

  function updateExpertControls() {
    if (!expertsTrack) return;
    const maxScroll = Math.max(0, expertsTrack.scrollWidth - expertsTrack.clientWidth);
    if (expertsPrevious) expertsPrevious.disabled = expertsTrack.scrollLeft <= 2;
    if (expertsNext) expertsNext.disabled = expertsTrack.scrollLeft >= maxScroll - 2;
  }

  function moveExperts(direction) {
    if (!expertsTrack) return;
    const card = expertsTrack.querySelector('.pu-expert');
    const distance = card ? card.getBoundingClientRect().width + 8 : expertsTrack.clientWidth * 0.82;
    expertsTrack.scrollBy({ left: distance * direction, behavior: reducedMotion ? 'auto' : 'smooth' });
  }

  if (expertsTrack) {
    expertsTrack.addEventListener('scroll', updateExpertControls, { passive: true });
    window.addEventListener('resize', updateExpertControls);
    window.requestAnimationFrame(updateExpertControls);
  }
  if (expertsPrevious) expertsPrevious.addEventListener('click', function () { moveExperts(-1); });
  if (expertsNext) expertsNext.addEventListener('click', function () { moveExperts(1); });
  });
})();
